const Graph = require('./BaseGraph')

module.exports = class PromoGraph extends Graph 
{
    constructor(apiDomain, path="promo")
    {
        super(apiDomain, path)
    }
    
    promoQuery(fields, params=null)
    {
        if (params)
            return { type: 'getPromo', query: this.queryString('getPromo', fields, params) }

        return { type: 'getPromo', query: `query getPromo ($location: String) {
            getPromo(location: $location)
            ${this.queryFields(fields)}
        }` }
    }
    
    

}